import { render, staticRenderFns } from "./RoomSettingModal.vue?vue&type=template&id=8990e188&scoped=true"
import script from "./RoomSettingModal.vue?vue&type=script&lang=js"
export * from "./RoomSettingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8990e188",
  null
  
)

export default component.exports